"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
var _dishLibrary = _interopRequireDefault(require("./dishLibrary.vue"));
var _makeMethodMange = _interopRequireDefault(require("./makeMethodMange.vue"));
var _makeMethodTypeManage = _interopRequireDefault(require("./makeMethodTypeManage.vue"));
var _dishForm = _interopRequireDefault(require("./dishForm.vue"));
var _goodsMakeMethod = _interopRequireDefault(require("./goodsMakeMethod.vue"));
var _estimateInfo = _interopRequireDefault(require("./estimateInfo.vue"));
var _makeMethodEstimateInfo = _interopRequireDefault(require("./makeMethodEstimateInfo.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '菜品库',
  components: {
    dishLibrary: _dishLibrary.default,
    makeMethodMange: _makeMethodMange.default,
    makeMethodTypeManage: _makeMethodTypeManage.default,
    dishForm: _dishForm.default,
    goodsMakeMethod: _goodsMakeMethod.default,
    estimateInfo: _estimateInfo.default,
    makeMethodEstimateInfo: _makeMethodEstimateInfo.default
  },
  data: function data() {
    return {
      activeName: 'dish',
      editTabs: [],
      tabIndex: 0,
      goodsMakeMethodDisplay: false,
      selectedGoodsId: null,
      estimateInfoDisplay: false,
      makeMethodEstimateInfoDisplay: false
    };
  },
  methods: {
    handleOpenMakeMethodEstimateInfo: function handleOpenMakeMethodEstimateInfo(payload) {
      console.log(payload);
      this.selectedGoodsId = payload.id;
      this.makeMethodEstimateInfoDisplay = true;
      this.activeName = 'makeMethodEstimateInfo';
    },
    handleOpenEstimateInfo: function handleOpenEstimateInfo(payload) {
      this.selectedGoodsId = payload.id;
      this.estimateInfoDisplay = true;
      this.activeName = 'estimateInfo';
    },
    handleOpenGoodsMakeMethod: function handleOpenGoodsMakeMethod(payload) {
      this.selectedGoodsId = payload.id;
      this.goodsMakeMethodDisplay = true;
      this.activeName = 'goodsMakeMethod';
    },
    handleTabClick: function handleTabClick() {},
    handleOpenEdit: function handleOpenEdit(payload) {
      var id = payload.id,
        title = payload.title;
      var name = "edit-".concat(++this.tabIndex);
      this.editTabs.push({
        name: name,
        title: title || '编辑菜品',
        goodsId: id,
        type: 'edit'
      });
      this.activeName = name;
    },
    handleOpenAdd: function handleOpenAdd() {
      var name = "add-".concat(++this.tabIndex);
      this.editTabs.push({
        name: name,
        title: '新增菜品',
        goodsId: null,
        type: 'add'
      });
      this.activeName = name;
    },
    closeEditTab: function closeEditTab(name, refreshed) {
      var tabs = this.editTabs;
      var active = this.activeName;
      if (active === name) {
        var idx = tabs.findIndex(function (t) {
          return t.name === name;
        });
        var next = tabs[idx + 1] || tabs[idx - 1];
        active = next ? next.name : 'dish';
      }
      this.activeName = active;
      this.editTabs = tabs.filter(function (t) {
        return t.name !== name;
      });
      // 让列表页自行刷新（可通过事件或总线实现）。这里简单触发一次自定义事件。
      if (refreshed) this.$emit('refresh-list');
    },
    removeTab: function removeTab(name) {
      if (name === 'goodsMakeMethod') {
        // 关闭 goodsMakeMethod 标签时隐藏它
        this.goodsMakeMethodDisplay = false;
        this.activeName = 'dish'; // 切换回默认标签
      } else if (name === 'estimateInfo') {
        // 关闭 estimateInfo 标签时隐藏它
        this.estimateInfoDisplay = false;
        this.activeName = 'dish'; // 切换回默认标签
      } else if (name === 'makeMethodEstimateInfo') {
        // 关闭 makeMethodEstimateInfo 标签时隐藏它
        this.makeMethodEstimateInfoDisplay = false;
        this.activeName = 'makeMethod'; // 切换回做法管理标签
      } else {
        this.closeEditTab(name, false);
      }
    }
  }
};